import React from 'react'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'

type Props = {
  loading: boolean,
}

export const LoadingBackdrop: React.FC<Props>  = (props) => {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => {
        // console.log('theme.zIndex.drawer', theme.zIndex.drawer)
        // console.log('theme.zIndex', theme.zIndex)
        return theme.zIndex.modal + 1
      } }}
      open={props.loading}
    >
      <CircularProgress
        color="inherit"
      />
    </Backdrop>
  )
}
export default LoadingBackdrop
